module.exports = __webpack_public_path__ + "static/media/chill-spins-150x150-dark.5b53618f.png";